import { api } from '../core';

interface UpdateChronologyEntryProviderResponse {
  success: boolean;
}

interface UpdateChronologyEntryProviderProps {
  abortController?: AbortController;
  entryId: string;
  providerId: string | null;
}

const chronologyEntryProviderUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateChronologyEntryProvider: builder.query<
      UpdateChronologyEntryProviderResponse,
      UpdateChronologyEntryProviderProps
    >({
      query: ({
        abortController = new AbortController(),
        entryId,
        providerId
      }: UpdateChronologyEntryProviderProps) => ({
        url: 'chronology/entry/provider/update',
        method: 'POST',
        body: {
          entry_id: entryId,
          provider_id: providerId
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in updateChronologyEntryProvider in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyUpdateChronologyEntryProviderQuery } = chronologyEntryProviderUpdateApi;
